import { render } from "./CustomFieldBuilder.vue?vue&type=template&id=a01dd894"
import script from "./CustomFieldBuilder.vue?vue&type=script&lang=js"
export * from "./CustomFieldBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__